import axios from 'axios';

async function createRevisionRequest(user, revision) {
  if (!user || !user.institution?.id) {
    throw new Error("createRevisionRequest(): missing user data");
  }
  const res = await axios.post(`${process.env["NEXT_PUBLIC__USERDATA_API"]}/api/CourseRevisions/`, {
    userID: user.id,
    userInstitutionID: user.institution.id,
    courseID: revision.courseId,
    portalID: revision.portalId,
    title: revision.name,
    content: JSON.stringify(revision.disabledContentIds)
  });
  return {
    ...revision,
    id: res.data.objectID,
    isActive: true,
    __syncedWithBackend: true
  };
}

export { createRevisionRequest };
//# sourceMappingURL=request.create.js.map
